import {IValuesStore} from "Stores/Values/types";
import {IManagementStore} from "Stores/Management/types";
import {IAuthStore} from "Stores/Auth/types";
import {inject, observer} from "mobx-react";
import React from "react";
import {Permission} from "@src/Interfaces/Entity/Permission";
import {computed, observable} from "mobx";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Values} from "Tools/Values";
import PermissionDialogForm
    from "@src/Components/Pages/Main/Content/Permissions/PermissionsContent/PermissonDialog/PermissonDialogForm/PermissionDialogForm";
import camelToTitle from "Tools/CamelToTitle";
import { IApplicationsStore } from "@src/Stores/Applications/types";

interface IPermissionDialogProps {
    initialValues: Permission;
    onConfirm: () => void;
    onClose: () => void;
    isOpened: boolean;
    values?: IValuesStore;
    management?: IManagementStore;
    auth?: IAuthStore;
    applicationsStore?: IApplicationsStore;
}

@inject("auth", "values", "management", "applicationsStore")
@observer
export class PermissionDialog extends React.Component<IPermissionDialogProps> {
    private dataFormRef: any;

    @observable isConfirmBtnDisabled: boolean = false;

    @computed get isEdit(): boolean {
        return !!this.props.initialValues;
    }

    @computed get allUserRoles() {
        return this.props.applicationsStore.roles;
    }

    @computed get selectedUserRoles() {
        return this.props.initialValues?.roles || [];
    }

    validateFieldUniqueness() {
        const originalName = this.props.initialValues?.name;
        const permissions = this.props.management.permissions;

        return function (value: string) {
            if (!value || value === originalName) {
                return true;
            }

            const filtered = permissions.find(
                (item) => item.name.toLowerCase() === value.toLowerCase()
            );

            return !filtered;
        }
    };

    onFormSubmit = async (values: Permission) => {
        try {
            await this.props.management.savePermission(values, !this.isEdit);
            this.props.onClose();
        } catch (error) {
            console.error(error);
        }
    };

    async onConfirmButtonClick() {
        this.dataFormRef.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
    };

    render() {
        return (
            <Dialog
                maxWidth={"lg"}
                open={this.props.isOpened}
                onClose={this.props.onClose}
            >
                <DialogTitle>
                    {this.isEdit ? Values.getLocalizationValue("editPermission") : Values.getLocalizationValue("addPermission")}
                </DialogTitle>

                <DialogContent style={{minWidth: 500, paddingBottom: 32}}>
                    <PermissionDialogForm
                        initialValues={this.props.initialValues}
                        setRef={ref => this.dataFormRef = ref}
                        uniquenessValidator={this.validateFieldUniqueness.bind(this)}
                        onSubmit={(data) => this.onFormSubmit(data)}
                        allRoles={this.allUserRoles}
                        selectedRoles={this.selectedUserRoles}
                    />
                </DialogContent>

                <DialogActions style={{padding: 16}}>
                    <Button
                        variant={"outlined"}
                        onClick={() => this.props.onClose()}
                        color="default"
                    >
                        {Values.getLocalizationValue("cancel")}
                    </Button>
                    <Button
                        variant={"contained"}
                        onClick={() => this.onConfirmButtonClick()}
                        disabled={this.isConfirmBtnDisabled}
                        color="primary"
                    >
                        {Values.getLocalizationValue("confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}